<div class="section-header">
    <div class="d-flex">
        <div class="w-100">
            <div class="container">
                <span class="h2">Information and Communication Technologies</span>
            </div>
        </div>
    </div>
</div>
<section>
    <div class="container pt-4">
        <p class="descrizioneSezione mb-1" >Il Centro Funzionale Multirischi assicura, ai sensi del vigente ordinamento regionale (d.G.r. n. 843/2017 e succ,va d.G.r. n. 64/2019), anche le competenze e attività necessarie al funzionamento di “sistemi, reti e apparati di telecomunicazione e centrali di gestione ed elaborazione dati, informazioni e comunicazioni di protezione civile”. Gli asset della protezione civile regionale, gestiti attualmente dal Centro Funzionale, sono quelli relativi ai tre seguenti principali ambiti tecnologici: 
            <br>1. Sistemi Informativi e di supporto alle decisioni; <br>2. Sistemi di trasmissione dati; <br>
            3. Sistemi di radiocomunicazioni a servizio del sistema regionale di protezione civile.</p>
    </div>
</section>
<div class="wrapper">
        <div class="container d-flex justify-content-between align-items-start">
            <div class="nav-tabs-navigation mt-2 pt-2 w-100" data-tabs-color="orange">
                <div class="nb-theme-default">
                    <nb-tabset id="tabset-docs" fullWidth>

                        <nb-tab tabTitle="Sistemi Informativi" style="overflow:hidden">
                            <div class="container d-flex justify-content-center">
                                <p class="descrizioneSezione" [innerHTML]="descrizioneSistemiInformativi"></p>
                            </div>
                        </nb-tab>

                        <nb-tab tabTitle="Trasmissione dati" style="overflow:hidden">
                            <div class="container d-flex justify-content-center">
                                <p class="descrizioneSezione" [innerHTML]="descrizioneTrasmissioneDati"></p>
                            </div>
                        </nb-tab>

                        <nb-tab tabTitle="Radio telecomunicazioni" style="overflow:hidden">
                            <div class="container d-flex justify-content-center">
                                <p class="descrizioneSezione" [innerHTML]="descrizioneRadio"></p>
                            </div>
                        </nb-tab>

                    </nb-tabset>
                </div>
            </div>
        </div>
</div>